(ns ductile.ui.components.waypoints
  (:require [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.components.table :as table]
            [ductile.ui.locale :refer [tr trn]]
            [ductile.ui.scene :as scene])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]))

(defn distance-duration-header [stop]
  [:div.text-xs.flex
   [:div "Vehicle count: " [:span.font-bold (:vehicle-count stop)]]
   [:span.pl-3 "Distance: " [:span.font-bold (:distance stop)]]
   [:span.pl-3 "Duration: " [:span.font-bold (:duration stop)]]])

(defn stop-header [stop]
  [:div.flex.gap-3.bg-slate-200.p-1.rounded-t-lg.pl-2.items-center.justify-between
   [:div.flex.items-center.gap-3 [ui/badge {:variant :yellow} (:number stop)]
    [:div
     [:div.font-bold.text-sm (:address/postcode stop) " " (:address/city stop)]
     [:div.text-xs (:address/name stop)]
     [distance-duration-header stop]]]
   [:div.gap-1.flex.flex-col
    [:button.p-1.rounded.hover:bg-slate-50.active:bg-slate-100.bg-slate-100.mr-8 [ui/icon :triangle-up]]
    [:button.p-1.rounded.hover:bg-slate-50.active:bg-slate-100.bg-slate-100.mr-8 [ui/icon :triangle-down]]]])

(defn load []
  [:div.flex.justify-center [:span.text-red-700.bg-red-200.rounded-full.p-1 [ui/icon {:size 14} :plus]]])

(defn unload []
  [:div.flex.justify-center [:span.text-green-800.bg-green-200.rounded-full.p-1 [ui/icon {:size 14} :minus]]])

(defn loadings-header [{:keys [loadings]}]
  [:div.bg-red-100.pl-3.flex.gap-1.items-center {:class "text-[11px]"} (trn ["Load %1 vehicle" "Load %1 vehicles"] loadings loadings)])

(defn unloadings-header [{:keys [unloadings]}]
  [:div.bg-green-100.pl-3.flex.gap-1.items-center {:class "text-[11px]"}  (trn ["Unload %1 vehicle" "Unload %1 vehicles"] unloadings unloadings)])

(defn actions []
  [:button.w-full.flex.justify-center [:div.bg-red-100.p-1.rounded.text-red-600.hover:bg-red-200.active:bg-red-300 [ui/icon :trash]]])

(defscene waypoints
  "Move buttons hide first/last,
   set background of entire row of vehicles loaded/unloaded,
   maybe make row height smaller"

  (let [direction #(let [bearing  %
                         distance 10
                         radius   14
                         stroke   2]
                     [:div.flex.justify-center
                      {:style {:transform-origin "center"}}
                      [:svg {:style {:width (* radius 2)
                                     :height (* radius 2)}}
                       [:g
                        [:circle {:cx radius :cy radius :r (- radius (/ stroke 2)) :fill "#eee" :stroke "#fff" :strokeWidth stroke :strokeLinecap "round"}]
                        [:line {:stroke "#ffffff" :strokeWidth 1 :strokeLinecap "round"
                                :x1 radius :y1 0 :x2 radius :y2 (* 2 radius)}]
                        [:line {:stroke "#ffffff" :strokeWidth 1 :strokeLinecap "round"
                                :x1 0 :y1 radius :x2 (* 2 radius) :y2 radius}]]
                       [:g {:style {:transform (str "rotate(" (js/Math.round bearing) "deg)")
                                    :transform-origin "center"}}
                        [:line {:stroke "#0091FF" :strokeWidth 3 :strokeLinecap "round"
                                :x1 radius :y1 radius :x2 radius :y2 (- radius (* radius 0.6))}]]]])]
    [:div.border.rounded.border-slate-300
     [:div.split-table.bg-slate-100.rounded-t.shadow-sm.px-3.py-2.flex-shrink-0.flex.items-center.justify-between
      {:data-testid "editing-load-pane"}
      [:div.flex.items-center.gap-3

       [:div.leading-none
        [:span.font-bold  "New load "]
        [:div {:class "mt-0.5"}
         [:span.text-xs
          [:span.font-bold "4 Stops"]
          [:span.ml-2 "Total distance: " [:span.font-bold "233.78 km"]]
          [:span.ml-2 "Total duration: "] [:span.font-bold "3h 32min"]]]]
       [:label.text-xs.inline-flex.gap-1.items-center.select-none.cursor-pointer.ml-2.self-end [:input.cursor-pointer {:type :checkbox}] "Sort by distance"]]

      [:div.flex.items-center.gap-2
       [ui/tooltip
        {:content (tr "Dismiss load")}
        [:div
         [ui/button
          {:variant :destructive
           :size 1}
          [ui/icon {:size 16} :trash]]]]
       [ui/tooltip
        {:content (tr "Confirm load")}
        [:div
         [ui/button
          {:variant :primary
           :size 1
           :data-testid "confirm-load"}
          [ui/icon {:size 16} :check]]]]]]

     [:div.flex-shrink-0.split-table.overflow-auto.shadow-sm.rounded-b
      [table/table
       {:hide-head? true
        :hide-columns [:ui.table/group-header]
        :column-widths {:direction 80}}
       [{:ui.table/group-header [stop-header {:number 1
                                              :address/name "ARS Altmann AG Krefeld Automobillogistik"
                                              :address/postcode "47804"
                                              :address/city "Krefeld"
                                              :distance "39.59 km"
                                              :duration "0h 32min"
                                              :vehicle-count 3}]}
        {:ui.table/group-header [loadings-header {:loadings 3} {:loadings 3}]}
        {:load-unload [load] :direction (direction 271) :vehicle/vin "WBA21BX0307S28053"	:vehicle/model "218i Active Tourer" :vehicle/make  "BMW" :actions [actions]}
        {:load-unload [load] :direction (direction 2)  :vehicle/vin "WBA21BX0807M56341"	:vehicle/model "218i Active Tourer" :vehicle/make  "BMW" :actions [actions]}
        {:load-unload [load] :direction (direction 14)  :vehicle/vin "WVGZZZE28SE025631"	:vehicle/model "ID.4" :vehicle/make  "Volkswagen" :actions [actions]}

        {:ui.table/group-header [stop-header {:number 2
                                              :address/name "BMW Niederlassung Düsseldorf Filiale Düsseldorf-Rath"
                                              :address/postcode "40472"
                                              :address/city "Düsseldorf"
                                              :distance "101.05 km"
                                              :duration "1h 15min"
                                              :vehicle-count 3}]}
        {:ui.table/group-header [unloadings-header {:unloadings 1}]}
        {:load-unload [unload] :direction (direction 184)  :vehicle/vin "WBA31AX000FR19934"	:vehicle/model "420d xDrive" :vehicle/make  "BMW" :actions [actions]}
        {:ui.table/group-header [loadings-header {:loadings 1}]}
        {:load-unload [load] :direction (direction 184)  :vehicle/vin "WBA31AX000FR19934"	:vehicle/model "420d xDrive" :vehicle/make  "BMW" :actions [actions]}

        {:ui.table/group-header [stop-header {:number 3
                                              :address/name "WELLER Premium GmbH"
                                              :address/postcode "33104"
                                              :address/city "Paderborn"
                                              :distance "56.09 km"
                                              :duration "1h 02min"
                                              :vehicle-count 3}]}
        {:ui.table/group-header [loadings-header {:loadings 2}]}
        {:load-unload [load] :direction (direction 111)  :vehicle/vin "WBA1EUNSPFJY48418"	:vehicle/model "X5 xDrive90d" :vehicle/make  "BMW" :actions [actions]}
        {:load-unload [load] :direction (direction 36)  :vehicle/vin "WBA21BX0307M57171"	:vehicle/model "218i Active Tourer" :vehicle/make  "BMW" :actions [actions]}
        {:ui.table/group-header [unloadings-header {:unloadings 2}]}
        {:load-unload [unload] :direction (direction 370)  :vehicle/vin "WBA31AX0X0FN49527"	:vehicle/model "420d xDrive" :vehicle/make  "BMW" :actions [actions]}
        {:load-unload [unload] :direction (direction 230)  :vehicle/vin "WBA11EV0109Y48419"	:vehicle/model "X5 xDrive30d" :vehicle/make  "BMW" :actions [actions]}

        {:ui.table/group-header [stop-header {:number 4
                                              :address/name "Tekken Emden GmbH & Co.KG"
                                              :address/postcode "26723"
                                              :address/city "Emden"
                                              :distance "23.14 km"
                                              :duration "0h 43min"
                                              :vehicle-count 5}]}
        {:ui.table/group-header [loadings-header {:loadings 2}]}
        {:load-unload [load] :direction (direction 38)  :vehicle/vin "WAUZZZGF2SA008025"	:vehicle/model "Q6" :vehicle/make  "Audi" :actions [actions]}
        {:load-unload [load] :direction (direction 50)  :vehicle/vin "TMBLH9NY7SF043551"	:vehicle/model "SKODA ENYAQ" :vehicle/make  "Skoda" :actions [actions]}]]]]))
